import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Language } from '../../types';
import { ChevronDown, Globe } from 'lucide-react';

const LanguageSelector: React.FC = () => {
  const { language, setLanguage, labels } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const languages: { code: Language; label: string }[] = [
    { code: 'da', label: labels.danish },
    { code: 'en', label: labels.english },
  ];

  const handleLanguageChange = (newLanguage: Language) => {
    setLanguage(newLanguage);
    setIsOpen(false);
  };

  const currentLanguageLabel = languages.find(lang => lang.code === language)?.label || labels.danish;

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-4 py-2 text-sm font-medium bg-white border-2 border-primary-200 rounded-lg hover:bg-primary-50 hover:border-primary-300 transition-all duration-200 shadow-sm"
        aria-label={labels.language}
      >
        <Globe size={16} className="text-primary-600" />
        <span className="text-primary-900">{currentLanguageLabel}</span>
        <ChevronDown size={16} className={`text-primary-600 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown */}
          <div className="absolute left-0 mt-1 bg-white border-2 border-primary-200 rounded-lg shadow-lg z-20 min-w-[120px] w-full">
            {languages.map((lang) => (
              <button
                key={lang.code}
                type="button"
                onClick={() => handleLanguageChange(lang.code)}
                className={`w-full text-left px-4 py-2 text-sm font-medium hover:bg-primary-50 transition-all duration-200 first:rounded-t-lg last:rounded-b-lg ${
                  language === lang.code ? 'bg-primary-100 text-primary-900' : 'text-primary-700'
                }`}
              >
                {lang.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector; 